import { Navigate, Route, Routes } from "react-router-dom";
import { SchoolAdminDashboard } from "../components/admin/SchoolAdmin/Dashboard/SchoolAdminDashboard";
import Layout from "../components/admin/SchoolAdmin/layout/Layout";
import CreateTeacher from "../components/admin/SchoolAdmin/Teacher/CreateTeacher";
import TenantProtectedRoutes from "./TenantProtectedRoutes";
import CreateStudent from "../components/admin/SchoolAdmin/Student/CreateStudent";
import EditTeacher from "../components/admin/SchoolAdmin/Teacher/EditTeacher";
import EditStudent from "../components/admin/SchoolAdmin/Student/EditStudent";
import { SchoolAdminTeacher } from "../components/admin/SchoolAdmin/Teacher/Teachers";
import { SchoolAdminStudent } from "../components/admin/SchoolAdmin/Student/Students";
import ReportsLayout from "../components/admin/SchoolAdmin/Reports/ReportsLayout";
import TeacherReport from "../components/admin/SchoolAdmin/Reports/TeacherReport";
import StudentReport from "../components/admin/SchoolAdmin/Reports/StudentReport";
import TeacherPerformanceSchool from "../components/admin/Organisation/School/TeacherPerformanceSchool";
import StudentPerformanceSchool from "../components/admin/Organisation/School/StudentPerformanceSchool";
import { OrgSchoolPerformance } from "../components/admin/SchoolAdmin/Organization/SchoolPerformance";
import { OrgSchoolInvoices } from "../components/admin/SchoolAdmin/Organization/OrgSchoolInvoices";
import { OrgSchoolLicensesActivity } from "../components/admin/SchoolAdmin/Organization/OrgSchoolLicensesActivity";
import { OrgPurchaseLicenses } from "../components/admin/SchoolAdmin/Organization/OrgPurchaseLicenses";
import {
  ManualPaymentForm,
  ManualPaymentInfo,
  PurchaseLicenses,
} from "../components/admin/SchoolAdmin/Account/License";
import AddMember from "../components/admin/SchoolAdmin/Account/Member/AddMember";
import EditMember from "../components/admin/SchoolAdmin/Account/Member/EditMember";
import {
  AdminProfilePage,
  MembersPage,
  PaymentsPage,
  LicensesPage,
  SchoolSessionPage,
} from "../components/admin/SchoolAdmin/Account/pages";
import SettingsLayout from "../components/admin/SchoolAdmin/Account/SettingsLayout";
import RolesPermissions from "../components/common/RolesPermissions";
import Invoice from "../components/admin/SchoolAdmin/Account/Payment/Invoice";
import ViewPayment from "../components/admin/SchoolAdmin/Account/Payment/ViewPayment";
import LicensePayment from "../components/admin/payment/LicensePayment";
import ImportHistoryLayout from "../components/admin/SchoolAdmin/ImportHistory/ImportHistoryLayout";
import StudentImportHistory from "../components/admin/SchoolAdmin/ImportHistory/StudentImportHistory";
import TeacherImportHistory from "../components/admin/SchoolAdmin/ImportHistory/TeacherImportHistory";
import ImportLogDetail from "../components/admin/SchoolAdmin/ImportHistory/ImportLogDetail";
import SchoolCreateNotification from "../components/admin/SchoolAdmin/Notification/CreateNotification";
import { SchoolNotifications } from "../components/admin/SchoolAdmin/Notification/Notification";
import { NotificationDetail } from "../components/admin/SchoolAdmin/Notification/NotificationDetail";
import { ReceivedNotificationDetail } from "../components/admin/SchoolAdmin/Notification/ReceivedNotificationDetail";
import Classroom from "../components/admin/TeacherAdmin/classroom/Classroom";
import SchoolAdminCreateClassroom from "../components/admin/SchoolAdmin/Classroom/SchoolAdminCreateClassroom";
import SchoolAdminUpdateClassroom from "../components/admin/SchoolAdmin/Classroom/SchoolAdminUpdateClassroom";
import ClassRoomDetail from "../components/admin/TeacherAdmin/classroom/classroomDetail/ClassRoomDetail";
import ClassroomReport from "../components/admin/TeacherAdmin/classroom/ClassroomReport/ClassroomReport";
import Quest from "../components/admin/TeacherAdmin/quest/Quest";
import Lessons from "../components/admin/TeacherAdmin/lesson/Lessons";
import UpdateLesson from "../components/admin/TeacherAdmin/lesson/UpdateLesson";

const SchoolAdminRoutes = () => {
  return (
    <>
      <Routes>
        <Route
          path=""
          element={
            <TenantProtectedRoutes tenantType="school-admin">
              <Layout />
            </TenantProtectedRoutes>
          }
        >
          <Route path="dashboard" element={<SchoolAdminDashboard />} />
          <Route path="teachers/create" element={<CreateTeacher />} />
          <Route path="teachers/edit/:teacherId" element={<EditTeacher />} />
          <Route path="students/create" element={<CreateStudent />} />
          <Route path="students/edit/:studentId" element={<EditStudent />} />
          <Route path="students" element={<SchoolAdminStudent />} />
          <Route path="teachers" element={<SchoolAdminTeacher />} />

          <Route path="classroom" element={<Classroom type="school-admin" />} />
          <Route
            path="classroom/create"
            element={<SchoolAdminCreateClassroom />}
          />
          <Route
            path="classroom/update/:id"
            element={<SchoolAdminUpdateClassroom />}
          />
          <Route
            path="classroom/detail/:id"
            element={<ClassRoomDetail type="school-admin" />}
          />
          <Route
            path="classroom/report/:id"
            element={<ClassroomReport type="school-admin" />}
          />

          <Route path="lesson" element={<Lessons type="School" />} />

          <Route
            path="lesson/update/:id/:teacherId"
            element={<UpdateLesson type="School" />}
          />

          <Route
            path="notification/create"
            element={<SchoolCreateNotification />}
          />
          <Route path="notifications" element={<SchoolNotifications />} />
          <Route
            path="notification/detail/:batch_id"
            element={<NotificationDetail />}
          />
          <Route
            path="notification/received/:notificationId"
            element={<ReceivedNotificationDetail />}
          />
          <Route
            path="organization/school-performance"
            element={<OrgSchoolPerformance />}
          />
          <Route path="organization/invoices" element={<OrgSchoolInvoices />} />
          <Route
            path="organization/licenses-activity"
            element={<OrgSchoolLicensesActivity />}
          />
          <Route
            path="organization/purchase-licenses"
            element={<OrgPurchaseLicenses />}
          />
          <Route path="/school/report" element={<ReportsLayout />}>
            <Route index element={<Navigate to="teachers" replace />} />
            <Route path="teachers" element={<TeacherReport />} />
            <Route
              path="teachers/:teacherId"
              element={<TeacherPerformanceSchool />}
            />
            <Route path="students" element={<StudentReport />} />
            <Route
              path="students/:studentId"
              element={<StudentPerformanceSchool />}
            />
          </Route>
          <Route
            path="import-history"
            element={<ImportHistoryLayout type="school-admin" />}
          >
            <Route index element={<Navigate to="students" replace />} />
            <Route
              path="students"
              element={<StudentImportHistory type="school-admin" />}
            />
            <Route
              path="students/:logId"
              element={<ImportLogDetail type="school-admin" />}
            />
            <Route
              path="teachers"
              element={<TeacherImportHistory type="school-admin" />}
            />
            <Route
              path="teachers/:logId"
              element={<ImportLogDetail type="school-admin" />}
            />
          </Route>

          <Route path="quest" element={<Quest />} />

          {/* Settings routes (nested route structure with SettingsLayout as parent) */}
          <Route path="settings" element={<SettingsLayout />}>
            <Route index element={<Navigate to="profile" replace />} />
            <Route path="profile" element={<AdminProfilePage />} />
            <Route path="session" element={<SchoolSessionPage />} />
            <Route path="members" element={<MembersPage />} />
            <Route path="payments" element={<PaymentsPage />} />
            <Route path="invoices" element={<Invoice />} />
            <Route path="licenses" element={<LicensesPage />} />
            <Route path="session" element={<SchoolSessionPage />} />
          </Route>

          <Route path="view/payment/:paymentId" element={<ViewPayment />} />
          <Route path="permissions" element={<RolesPermissions />} />
          <Route
            path="settings/purchase-licenses"
            element={<PurchaseLicenses />}
          />
          <Route
            path="settings/purchase-licenses/manual-payment-info"
            element={<ManualPaymentInfo />}
          />
          <Route
            path="/purchase-licenses/manual-payment-form/:paymentId"
            element={<ManualPaymentForm />}
          />
          <Route
            path="settings/purchase-licenses/manual-payment-form"
            element={<ManualPaymentForm />}
          />
          <Route path="settings/members/add" element={<AddMember />} />
          <Route
            path="settings/members/edit/:memberId"
            element={<EditMember />}
          />
          <Route path="/:invoiceId/payment" element={<LicensePayment />} />

          <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Route>
      </Routes>
    </>
  );
};

export default SchoolAdminRoutes;
